/** @jsxImportSource react */

export function SimuladorBancasView() {
  return (
    <div
      className="flex h-full flex-col"
      style={{ backgroundColor: "#F4F8FB" }}
    >
      {/* Main content area - grows to fill space */}
      <div className="flex min-h-0 flex-1 gap-4 p-4">
        {/* Single Column - Full Width */}
        <div className="flex w-full flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              Simulador Electoral
            </h2>
          </div>

          {/* Panel Content - takes all available height */}
          <div className="relative flex min-h-0 min-w-0 flex-1">
            {/* Full width iframe */}
            <div className="absolute inset-0 flex items-center justify-center">
              <iframe
                src="https://simulador.poderciudadano.org/"
                title="Simulador de Bancas"
                className="h-full w-full border-0"
                sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
